import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RegistreService } from './registre.service';

@Component({
    selector: 'app-registre',
    templateUrl: './registre.component.html',
    styleUrls: ['./registre.component.scss']
})
export class RegistreComponent implements OnInit {
    portalLive: boolean = environment.portalLive;

    step: number = 1;
    tipRegistru: string = '';
    numeRegistru: string = '';
    tipuriRegistre = [
        // {
        //     title: "Autorizări comerciale",
        //     id: "autorizari",
        // },
        {
            title: "Urbanism",
            id: "urbanism",
        },
    ]

    constructor(
        private http: HttpClient,
        private registreService: RegistreService,
    ) { }

    ngOnInit(): void { }

    onTipRegistruChange(id: string, title: string) {
        this.step = 2;
        this.tipRegistru = id;
        this.numeRegistru = title;
    }

    goBackToStep1() {
        this.step = 1;
        this.tipRegistru = '';
        this.numeRegistru = '';
    }
}
